import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UnMedida } from '../interfaces/un-medida';
import { PageResult } from '../interfaces/page-result';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProdutoUnMedidaService {


  readonly url = `${environment.apiURL}/un/medida`;

  constructor(private http: HttpClient) { }

    getUnMedidaPage(page?: number, size?: number): Observable<PageResult<UnMedida>> {
      return this.http.get<PageResult<UnMedida>>(
        `${this.url}/page/get?page=${page}&size=${size}`);
    }

    getUnMedidaPageSearch(page?: number, size?: number,
      search?: string, order?: string, direction?: string, desativado?: boolean): Observable<PageResult<UnMedida>> {
      return this.http.get<PageResult<UnMedida>>(`${this.url}/page/get/?page=${page}&size=${size}&search=${search}`
        + `&order=${order}&direction=${direction}&desativado=${desativado}`);
    }

    getUnMedidaList(): Observable<UnMedida[]> {
      return this.http.get<UnMedida[]>(
        `${this.url}/lista/get?size=200`);
    }
  
    saveOrUpdate(unMedida: UnMedida): Observable<UnMedida> {
      return this.http.put<UnMedida>(`${this.url}`, unMedida);
    }


}
